import React from 'react';
import { AppColors } from '@lib/common';
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  TableProps,
  TableCellProps,
} from '@material-ui/core';

interface CellProps extends TableCellProps {
  isLastRow?: boolean;
}

const sectionHeaderCellStyle = {
  fontWeight: 700,
  backgroundColor: AppColors.LightGray,
  color: AppColors.DarkBlue,
  textTransform: 'uppercase' as const,
  letterSpacing: '0.04em',
};

const labelCellStyle = {
  fontWeight: 'bold' as const,
  width: '30%',
};

const lastRowCellStyle = {
  borderBottom: 'none',
};

export function StyledTable(props: TableProps) {
  return <Table size="small" {...props} />;
}

export function StyledTableBody(props: React.ComponentProps<typeof TableBody>) {
  return <TableBody {...props} />;
}

export function SectionHeaderRow({ children }: { children?: React.ReactNode }) {
  return (
    <TableRow>
      <TableCell colSpan={2} style={sectionHeaderCellStyle}>
        {children}
      </TableCell>
    </TableRow>
  );
}

export function LabelCell({ isLastRow, style, ...props }: CellProps) {
  return (
    <TableCell
      style={{
        ...labelCellStyle,
        ...(isLastRow ? lastRowCellStyle : {}),
        ...style,
      }}
      {...props}
    />
  );
}

export function ValueCell({ isLastRow, style, ...props }: CellProps) {
  return (
    <TableCell
      style={{
        ...(isLastRow ? lastRowCellStyle : {}),
        ...style,
      }}
      {...props}
    />
  );
}

export function ValueText({ children }: { children?: React.ReactNode }) {
  return (
    <Typography component="span" variant="body2">
      {children}
    </Typography>
  );
}
